import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/css/global.css'
import VCharts from 'v-charts'
import VueResource from 'vue-resource'
import Axios from 'axios' // 导入axios
// 引入echarts
import echarts from 'echarts'
import netConfig from "../config/net.config";

Vue.prototype.$echarts = echarts
Vue.use(VueResource)
// Vue.http.options.root = "http://192.168.0.10:8089/" //
// Vue.http.options.root = "https://admin.ciaojian.com/" //服务器//
// Vue.http.options.root = "http://192.168.0.173:8080/"
// Vue.http.options.root = "https://www.ad.ciaojian.com/" //服务器
// Vue.http.options.root = "https://ciaojian.cn1.utools.club/"
Axios.defaults.withCredentials = true//axios允许携带cooke
Vue.http.options.root = netConfig.baseUrl
Vue.http.options.emulateJSON = true
//vue-resource拦截器
Vue.http.interceptors.push((request, next) => {
    request.credentials = true;//vue-sesource允许携带cookie
    if (localStorage.getItem('Authorization')) {
        request.headers.set('Authorization', localStorage.getItem('Authorization'));
        next((response) => {
            if (response.body.code == 401) {
                localStorage.removeItem("Authorization")
                localStorage.setItem('serrmsg', response.body.msg)
                if (window.location.href.split("/#/")[1] != "login") {
                    router.push({path: '/login'})
                }
            }
            // if(response.body.code==402){
            // 		 localStorage.removeItem("Authorization")
            // 		 localStorage.setItem('serrmsg',response.body.msg)
            // 		router.push({path:'/login'})
            // }
            return response;
        })
    }
});
import moment from 'moment'
// 复制内容
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

// require styles 引入样式
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import FormatTime from './utils/index.js'

// 引用富文本
import VueQuillEditor from 'vue-quill-editor'

Vue.use(VueQuillEditor)
// 百度富文本
// import vueEditor from 'vue-editor-interline'
// Vue.use(vueEditor)
import vueEditor from 'vue-editor-interline'
import 'vue-editor-interline/lib/vue-editor-interline.css'

// 引用百度地图
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
    /* 需要注册百度地图开发者来获取你的ak */
    ak: 'IF7MiqCFrw8GYPRpxKUKhObAVCEbQThZ'
})
Vue.use(vueEditor)

import wxlogin from 'vue-wxlogin';

Vue.use(wxlogin)


// 定义全局过滤器
Vue.filter('dataFormat', function (datastr, pattren = "YYYY-MM-DD HH:mm:ss") {
    return moment(datastr).format(pattren)
})
Vue.config.productionTip = false
Vue.use(VCharts)
new Vue({
    router,
    FormatTime,
    render: h => h(App)
}).$mount('#app')

// 全局定义时间函数
Vue.filter('dataFormat', function (originVal) {
    const dt = new Date(originVal)
    const y = dt.getFullYear()
    const m = (dt.getMonth() + 1 + '').padStart(2, '0')
    const d = (dt.getDate() + '').padStart(2, '0')
    return `${y}-${m}-${d}`
})
